import { useTranslation } from "react-i18next";
import BookingChat from "@/components/BookingChat";

export function HostMessages({ trips, selected, setSelected }) {
  const { t: tr } = useTranslation();
  const sel = trips.find((t) => t.id === selected) || null;
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4" data-testid="host-messages">
      <div className="lg:col-span-1 bg-white rounded-2xl shadow-card border border-slate-100 p-3 max-h-[32rem] overflow-y-auto">
        {trips.length === 0 ? (
          <p className="text-slate-400 text-sm p-4" data-testid="msg-empty">{tr("hostMessages.empty")}</p>
        ) : (
          trips.map((t) => (
            <button key={t.id} data-testid={`msg-thread-${t.id}`} onClick={() => setSelected(t.id)}
              className={`w-full text-left p-3 rounded-xl mb-1 transition-colors ${selected === t.id ? "bg-blue-50" : "hover:bg-slate-50"}`}>
              <p className="font-medium text-slate-900 text-sm">{t.guest}</p>
              <p className="text-xs text-slate-500">{t.car_name}</p>
              <p className="text-xs text-slate-400">{t.pickup_date} → {t.return_date}</p>
            </button>
          ))
        )}
      </div>
      <div className="lg:col-span-2">
        {sel ? (
          <BookingChat key={sel.id} bookingId={sel.id} role="host" endpoint={`/host/me/bookings/${sel.id}/messages`} />
        ) : (
          <div data-testid="msg-placeholder" className="bg-white rounded-2xl shadow-card border border-slate-100 p-10 text-center text-slate-400 h-80 grid place-items-center">
            {tr("hostMessages.placeholder")}
          </div>
        )}
      </div>
    </div>
  );
}
